import {
  WIFI_THERMOSTATS_REQUEST,
  WIFI_THERMOSTATS_REQUEST_FAILED,
  WIFI_THERMOSTATS_REQUEST_SUCCESS,
  WifiThermostatsRequestSuccess,
} from '../types/wifiThermostats';
import { Query } from '../../utils/query';
import { ErrorMessage } from '../../types/main';

export const wifiThermostatsRequest = (query?: Query) => ({
  type: WIFI_THERMOSTATS_REQUEST,
  payload: query,
} as const);

export const wifiThermostatsRequestFailed = (payload: ErrorMessage) => ({
  type: WIFI_THERMOSTATS_REQUEST_FAILED,
  payload,
} as const);

export const wifiThermostatsRequestSuccess = (payload: WifiThermostatsRequestSuccess) => ({
  type: WIFI_THERMOSTATS_REQUEST_SUCCESS,
  payload,
} as const);
